import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import ExpandingSection from "../../../../components/expanding-section/ExpandingSection";
import { createId, Json } from "./base";
import InputList from "./Input";
import Template, { MapParameters } from "./Template";

export default function WorkflowServiceManual({ json, onChange, rootJson }: {
    json: Json;
    onChange: (current: ((json: Json) => Json)) => void;
    rootJson: Json
}): ReactElement {
    const connection = json.connection as Json;
    const changeConnection = (child: Json) => {
        onChange(current => ({
            ...current,
            connection: {
                ...connection,
                ...child,
            },
        }));
    };
    const deleteKey = (key: string) => {
        onChange(current => {
            const copy = { ...current };
            delete (copy.connection as Record<string, string>)[key];
            return copy;
        });
    };

    if (connection?.manual) {
        const manual = connection?.manual as Json | undefined;
        const changeManual = (child: Json) => {
            changeConnection({
                manual: {
                    ...manual,
                    ...child,
                },
            });
        };
        return (
            <div>
                <div
                    className="d-flex justify-content-between align-items-start"
                >
                    <h5>Manual Config</h5>
                    <button
                        type="button"
                        className="btn btn-none btn-sm p-0 text-light  "
                        onClick={() => deleteKey("manual")}
                    >
                        <BiTrash />
                    </button>

                </div>

                <ExpandingSection title="User Facing">
                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">Instructions</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Please click Authorize to continue"
                            required
                            as="textarea"
                            onChange={evt => changeManual({ instructions: evt.target.value })}
                            value={manual?.instructions as string ?? ""}
                        />
                        <Form.Text>
                            Instructions shown to the end users
                        </Form.Text>
                    </Form.Group>

                    <h5>Input</h5>

                    <InputList
                        json={manual?.input as Json[] ?? []}
                        rootJson={rootJson}
                        onChange={value => changeManual({
                            input: value,
                        })}
                    />

                </ExpandingSection>

                <ExpandingSection title="Connection">

                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">Url</Form.Label>
                        <Template
                            json={(manual?.connection as Json)?.url as Json}
                            onChange={value => changeManual({
                                connection: {
                                    ...(manual?.connection as Json),
                                    url: value,
                                },
                            })}

                        />
                        <Form.Text className="d-block">
                            This helps set up a default url that applies to all downstream requests.
                        </Form.Text>
                    </Form.Group>

                    <MapParameters
                        title="Headers"
                        json={(manual?.connection as Json)?.headers as Json}
                        onChange={value => {
                            changeManual({
                                connection: {
                                    ...(manual?.connection as Json),
                                    headers: value,
                                },
                            });
                        }}
                    />
                </ExpandingSection>

            </div>
        );
    }

    return (
        <button
            type="button"
            className="btn btn-primary py-1 px-2"
            onClick={() => changeConnection({
                id: `urn:fq:workflow-service-connection:(urn:fq:workflow-service:${json.id},${createId()})`,
                ...connection,
                manual: {},
            })}
        >
            Manual
        </button>
    );
}
